import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,

        menus: []
    },

    mutations: {
        setMenus(state, menus) {
            state.menus = menus;
        },

        setLoading(state, loading) {
            state.loading = loading;
        }
    },

    actions: {
        loadMenus(context) {
            context.commit('setLoading', true);

            return HTTP.get('/menus')
                .then(resp => {
                    let menus = resp.data;

                    context.commit('setMenus', menus);
                    context.commit('setLoading', false);
                })
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/menu.js